import React from 'react';
import { useLocation } from 'react-router-dom';
import { useConsumerDetail } from '../hook';
import { User } from 'lucide-react';
import { getRemoteUtilityId } from '@shared/utils/getUtilityId';
import { useTranslation } from 'react-i18next';

export const ActiveAccountBanner = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isSubAccount = searchParams.get('isSubAccount') === 'true';
  const urlConsumerId = searchParams.get('consumerId');
  const remoteUtilityId = getRemoteUtilityId();

  const { data: consumerDetailResult, isLoading } = useConsumerDetail({
    remote_utility_id: remoteUtilityId,
    consumer_id: urlConsumerId || undefined
  }, { enabled: !!urlConsumerId && isSubAccount });

  // Only show the banner if we are raising a request for a specific sub-account
  if (!isSubAccount || !urlConsumerId) return null;

  if (isLoading) {
    return (
      <div className="mb-6 bg-blue-50/50 border border-blue-100 rounded-xl p-4 flex items-center gap-2">
        <User className="w-4 h-4 text-blue-600/50 animate-pulse" />
        <span className="text-sm text-blue-600 animate-pulse">{t("Loading consumer details...")}</span>
      </div>
    );
  }

  const detail = consumerDetailResult?.result;
  if (!detail) return null;

  const name = `${detail.firstName || ''} ${detail.lastName || ''}`.trim();
  const accountNo = detail.consumerNo || 'N/A';

  return (
    <div className="mb-6 bg-blue-50/50 border border-blue-100 rounded-xl p-4">
      <div className="flex items-center gap-2 mb-1">
        <User className="w-4 h-4 text-blue-600" />
        <h4 className="text-sm font-semibold text-blue-900">{t("Raising Request For")}</h4>
      </div>
      <div className="text-sm text-blue-800 ml-6">
        <span className="font-semibold">{name}</span> {name && accountNo ? '•' : ''} {t("Account")}: {accountNo}
      </div>
    </div>
  );
};
